var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/theme/MindbodyBase.tsx
import { createTheme } from "@mui/material/styles";

// src/theme/sections/colors.ts
var colors = {
  basil: {
    50: "#e1f4f1",
    100: "#ebf9f1",
    200: "#93f7ca",
    300: "#67d7a4",
    400: "#11a884",
    500: "#008363",
    600: "#045944",
    700: "#004030"
  },
  black: {
    50: "#fcfcfc",
    100: "#f4f5f5",
    200: "#e4e5e5",
    300: "#cccccc",
    400: "#a2a3a5",
    500: "#57585a",
    600: "#2d2d2d",
    700: "#000000"
  },
  blue: {
    50: "#e3f2fd",
    100: "#badefa",
    200: "#8ec9f7",
    300: "#61b4f4",
    400: "#3ca4f3",
    500: "#1195f1",
    600: "#0d87e3",
    700: "#0675d0",
    800: "#0164be",
    900: "#00469f",
    a100: "#80d8ff",
    a200: "#40c4ff",
    a400: "#00b0ff",
    a700: "#0091ea"
  },
  green: {
    50: "#e0f4ef",
    100: "#b4e3d7",
    200: "#84d1bd",
    300: "#52bfa3",
    400: "#2cb090",
    500: "#07a17e",
    600: "#059372",
    700: "#008363",
    800: "#007354",
    900: "#005739",
    a100: "#b9f6ca",
    a200: "#69f0ae",
    a400: "#00e676",
    a700: "#00c853"
  },
  grey: {
    50: "#fafbfb",
    100: "#f5f6f6",
    200: "#f0f1f1",
    300: "#e4e5e5",
    400: "#c2c3c3",
    500: "#a3a4a4",
    600: "#7a7b7b",
    700: "#656666",
    800: "#464747",
    900: "#252626",
    a100: "#f5f5f5",
    a200: "#eeeeee",
    a400: "#bdbdbd",
    a700: "#616161"
  },
  lime: {
    50: "#f9fde7",
    100: "#fffee2",
    200: "#e9fed3",
    300: "#d1f9b1",
    400: "#d6f04d"
  },
  orange: {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    1e3: "#802D00",
    a100: "#ffd180",
    a200: "#ffab40",
    a400: "#ff9100",
    a700: "#ff6d00"
  },
  pink: {
    50: "#fbe6f1",
    100: "#f7c0dc",
    200: "#f497c5",
    300: "#f36dad",
    400: "#f24e99",
    500: "#f33184",
    600: "#e02f7f",
    700: "#c92c78",
    800: "#b32972",
    900: "#8c2466"
  },
  red: {
    50: "#feebee",
    100: "#fecdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    1e3: "#9E1818",
    a100: "#ff8a80",
    a200: "#ff5252",
    a400: "#ff1744",
    a700: "#d50000"
  },
  teal: {
    50: "#e0f6fb",
    100: "#e5f2f4",
    200: "#80d9ec",
    300: "#4ecae3",
    400: "#2cbfdb",
    500: "#19b4d4",
    600: "#15a5c1",
    700: "#0f90a6",
    800: "#0a7b8e",
    900: "#045a63"
  },
  vermillion: {
    50: "#fff7f4",
    100: "#ffcdc0",
    200: "#ffac97",
    300: "#ff8b6e",
    400: "#ff714f",
    500: "#ff5732",
    600: "#fb512e",
    700: "#ed4a29",
    800: "#df4325",
    900: "#c5361c"
  },
  yellow: {
    50: "#fffde7",
    100: "#fff9c4",
    200: "#fff59d",
    300: "#fff176",
    400: "#ffee58",
    500: "#ffeb3b",
    600: "#fdd835",
    700: "#fcbf51",
    800: "#f9a825",
    900: "#f57f17",
    a100: "#ffff8d",
    a200: "#ffff00",
    a400: "#ffea00",
    a700: "#ffd600"
  },
  whites: {
    50: "#ffffff",
    100: "#fafafa",
    200: "#f5f5f5",
    300: "#f0f0f0",
    400: "#dedede",
    500: "#c2c2c2",
    600: "#979797"
  },
  neu: {
    0: "#FFFFFF",
    1: "#F9FAFB",
    2: "#F3F4F6",
    3: "#DDDFE5",
    4: "#C4C9D4",
    5: "#959EB2",
    6: "#66748E",
    7: "#566176",
    8: "#2D2D2D"
  }
};
var getColorPercentage = (color, percentage) => {
  const hex = color.match(/\w\w/g);
  const a = percentage / 100;
  if (hex) {
    const [r, g, b] = hex.map((x) => parseInt(x, 16));
    return `rgba(${r},${g},${b},${a})`;
  }
  return color;
};

// src/theme/sections/palette.tsx
var paletteBusiness = {
  mode: "light",
  action: {
    active: getColorPercentage(colors.black[700], 56),
    disabled: getColorPercentage(colors.black[700], 50),
    disabledBackground: getColorPercentage(colors.black[700], 8),
    focus: getColorPercentage(colors.black[700], 12),
    hover: getColorPercentage(colors.black[700], 4),
    selected: getColorPercentage(colors.black[700], 8)
  },
  background: {
    default: colors.whites[50],
    paper: colors.whites[50]
  },
  common: {
    black: colors.black[700],
    white: colors.whites[50]
  },
  divider: getColorPercentage(colors.black[600], 12),
  error: {
    contrastText: colors.whites[50],
    dark: colors.red[800],
    focusVisible: getColorPercentage(colors.red[700], 30),
    hover: getColorPercentage(colors.red[700], 4),
    light: colors.red[400],
    main: colors.red[700],
    selected: getColorPercentage(colors.red[700], 50),
    outlinedBorder: getColorPercentage(colors.red[700], 50)
  },
  info: {
    contrastText: colors.whites[50],
    dark: colors.blue[900],
    focusVisible: getColorPercentage(colors.blue[600], 30),
    hover: getColorPercentage(colors.blue[600], 4),
    light: colors.blue[400],
    main: colors.blue[600],
    outlinedBorder: getColorPercentage(colors.blue[600], 50),
    selected: getColorPercentage(colors.blue[600], 8)
  },
  primary: {
    contrastText: colors.whites[50],
    dark: colors.teal[900],
    focus: getColorPercentage(colors.teal[800], 12),
    focusVisible: getColorPercentage(colors.teal[800], 30),
    hover: getColorPercentage(colors.teal[800], 4),
    light: colors.teal[600],
    main: colors.teal[800],
    outlinedBorder: getColorPercentage(colors.black[600], 18),
    selected: getColorPercentage(colors.teal[800], 8)
  },
  secondary: {
    contrastText: colors.black[600],
    dark: colors.whites[300],
    focus: getColorPercentage(colors.black[700], 12),
    focusVisible: getColorPercentage(colors.black[700], 30),
    hover: getColorPercentage(colors.black[700], 4),
    light: colors.whites[50],
    main: colors.whites[100],
    outlinedBorder: getColorPercentage(colors.black[700], 15),
    selected: getColorPercentage(colors.black[700], 8)
  },
  success: {
    contrastText: colors.whites[50],
    dark: colors.green[700],
    focusVisible: getColorPercentage(colors.green[600], 30),
    hover: getColorPercentage(colors.green[600], 4),
    light: colors.green[400],
    main: colors.green[500],
    outlinedBorder: getColorPercentage(colors.green[600], 50),
    selected: getColorPercentage(colors.green[600], 8)
  },
  text: {
    disabled: getColorPercentage(colors.black[700], 38),
    primary: getColorPercentage(colors.black[700], 87),
    secondary: getColorPercentage(colors.black[700], 60)
  },
  warning: {
    contrastText: colors.whites[50],
    dark: colors.orange[900],
    focusVisible: getColorPercentage(colors.orange[800], 30),
    hover: getColorPercentage(colors.orange[800], 4),
    light: colors.orange[500],
    main: colors.orange[800],
    selected: getColorPercentage(colors.orange[800], 8),
    outlinedBorder: getColorPercentage(colors.orange[800], 50)
  }
};
var paletteConsumer = {
  mode: "light",
  action: {
    active: getColorPercentage(colors.black[700], 56),
    disabled: getColorPercentage(colors.black[700], 50),
    disabledBackground: getColorPercentage(colors.black[700], 8),
    focus: getColorPercentage(colors.black[700], 12),
    hover: getColorPercentage(colors.black[700], 4),
    selected: getColorPercentage(colors.black[700], 8)
  },
  background: {
    default: colors.whites[50],
    paper: colors.whites[50]
  },
  common: {
    black: colors.black[700],
    white: colors.whites[50]
  },
  divider: getColorPercentage(colors.black[600], 12),
  error: {
    contrastText: colors.whites[50],
    dark: colors.red[800],
    focusVisible: getColorPercentage(colors.red[700], 30),
    hover: getColorPercentage(colors.red[700], 4),
    light: colors.red[400],
    main: colors.red[700],
    selected: getColorPercentage(colors.red[700], 50),
    outlinedBorder: getColorPercentage(colors.red[700], 50)
  },
  info: {
    contrastText: colors.whites[50],
    dark: colors.blue[900],
    focusVisible: getColorPercentage(colors.blue[600], 30),
    hover: getColorPercentage(colors.blue[600], 4),
    light: colors.blue[400],
    main: colors.blue[600],
    outlinedBorder: getColorPercentage(colors.blue[600], 50),
    selected: getColorPercentage(colors.blue[600], 8)
  },
  primary: {
    contrastText: colors.whites[50],
    dark: colors.vermillion[800],
    focus: getColorPercentage(colors.vermillion[800], 12),
    focusVisible: getColorPercentage(colors.vermillion[800], 30),
    hover: getColorPercentage(colors.vermillion[800], 4),
    light: colors.vermillion[400],
    main: colors.vermillion[700],
    outlinedBorder: getColorPercentage(colors.black[600], 15),
    selected: getColorPercentage(colors.vermillion[800], 8)
  },
  secondary: {
    contrastText: colors.black[600],
    dark: colors.whites[300],
    focus: getColorPercentage(colors.black[700], 12),
    focusVisible: getColorPercentage(colors.black[700], 30),
    hover: getColorPercentage(colors.black[700], 4),
    light: colors.whites[50],
    main: colors.whites[100],
    outlinedBorder: getColorPercentage(colors.black[700], 15),
    selected: getColorPercentage(colors.black[700], 8)
  },
  success: {
    contrastText: colors.whites[50],
    dark: colors.green[700],
    focusVisible: getColorPercentage(colors.green[600], 30),
    hover: getColorPercentage(colors.green[600], 4),
    light: colors.green[400],
    main: colors.green[500],
    outlinedBorder: getColorPercentage(colors.green[600], 50),
    selected: getColorPercentage(colors.green[600], 8)
  },
  text: {
    disabled: getColorPercentage(colors.black[700], 38),
    primary: getColorPercentage(colors.black[700], 87),
    secondary: getColorPercentage(colors.black[700], 60)
  },
  warning: {
    contrastText: colors.whites[50],
    dark: colors.orange[900],
    focusVisible: getColorPercentage(colors.orange[800], 30),
    hover: getColorPercentage(colors.orange[800], 4),
    light: colors.orange[500],
    main: colors.orange[800],
    selected: getColorPercentage(colors.orange[800], 8),
    outlinedBorder: getColorPercentage(colors.orange[800], 50)
  }
};
var paletteRebrand = {
  mode: "light",
  action: {
    active: colors.neu[6],
    hover: getColorPercentage(colors.neu[8], 4),
    selected: getColorPercentage(colors.neu[8], 8),
    focus: getColorPercentage(colors.neu[8], 12),
    disabled: colors.neu[4],
    disabledBackground: colors.neu[2]
  },
  background: {
    default: colors.neu[0],
    paper: colors.neu[0]
  },
  common: {
    black: colors.neu[8],
    white: colors.neu[0]
  },
  divider: colors.neu[3],
  error: {
    main: colors.red[700],
    dark: colors.red[1e3],
    light: colors.red[50],
    hover: getColorPercentage(colors.red[700], 4),
    selected: getColorPercentage(colors.red[700], 8),
    focusVisible: getColorPercentage(colors.red[700], 32),
    outlinedBorder: getColorPercentage(colors.red[700], 48),
    contrastText: colors.neu[0]
  },
  info: {
    main: colors.blue[600],
    dark: colors.blue[900],
    light: colors.blue[50],
    hover: getColorPercentage(colors.blue[600], 4),
    selected: getColorPercentage(colors.blue[600], 8),
    focusVisible: getColorPercentage(colors.blue[600], 32),
    outlinedBorder: getColorPercentage(colors.blue[600], 48),
    contrastText: colors.neu[0]
  },
  primary: {
    main: colors.neu[8],
    dark: colors.neu[7],
    light: colors.neu[2],
    contrastText: colors.neu[0],
    hover: getColorPercentage(colors.neu[8], 4),
    selected: getColorPercentage(colors.neu[8], 8),
    focus: getColorPercentage(colors.neu[8], 12),
    focusVisible: getColorPercentage(colors.neu[8], 20),
    outlinedBorder: colors.neu[3]
  },
  secondary: {
    main: colors.basil[500],
    dark: colors.basil[700],
    light: colors.basil[100],
    contrastText: colors.neu[0],
    hover: getColorPercentage(colors.basil[500], 4),
    selected: getColorPercentage(colors.basil[500], 8),
    focus: getColorPercentage(colors.basil[500], 12),
    focusVisible: getColorPercentage(colors.basil[500], 28),
    outlinedBorder: colors.neu[3]
  },
  success: {
    main: colors.green[600],
    dark: colors.green[900],
    light: colors.green[50],
    hover: getColorPercentage(colors.green[600], 4),
    selected: getColorPercentage(colors.green[600], 8),
    focusVisible: getColorPercentage(colors.green[600], 32),
    outlinedBorder: getColorPercentage(colors.green[600], 48),
    contrastText: colors.neu[0]
  },
  text: {
    primary: colors.neu[8],
    secondary: colors.neu[7],
    disabled: colors.neu[4]
  },
  warning: {
    main: colors.orange[800],
    dark: colors.orange[1e3],
    light: colors.orange[50],
    hover: getColorPercentage(colors.orange[800], 4),
    selected: getColorPercentage(colors.orange[800], 8),
    focusVisible: getColorPercentage(colors.orange[800], 32),
    outlinedBorder: getColorPercentage(colors.orange[800], 48),
    contrastText: colors.neu[0]
  }
};

// src/theme/sections/components/MuiAlert.tsx
import React from "react";
var MuiAlert = {
  defaultProps: {
    action: /* @__PURE__ */ React.createElement(React.Fragment, null)
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      let borderColor = theme.palette.primary.main;
      switch (ownerState == null ? void 0 : ownerState.severity) {
        case "error":
          borderColor = theme.palette.error.main;
          break;
        case "info":
          borderColor = theme.palette.info.main;
          break;
        case "success":
          borderColor = theme.palette.success.main;
          break;
        case "warning":
          borderColor = theme.palette.warning.main;
          break;
        default:
          borderColor = theme.palette.primary.main;
      }
      return {
        border: `1px solid ${borderColor}`,
        borderRadius: "4px",
        "& .MuiAlert-message": {
          padding: "10px 0"
        }
      };
    }
  }
};

// src/theme/sections/components/MuiAlertTitle.tsx
var MuiAlertTitle = {
  styleOverrides: {
    root: {
      fontSize: "16px",
      fontWeight: 600,
      letterSpacing: "0.15px",
      marginBottom: "2px",
      marginTop: "-5px"
    }
  }
};

// src/theme/sections/components/MuiAvatar.tsx
var MuiAvatar = {
  styleOverrides: {
    root: ({ ownerState }) => {
      const size = ownerState.sizes || 40;
      return {
        backgroundColor: colors.grey[400],
        height: size,
        width: size
      };
    }
  }
};

// src/theme/sections/components/MuiBreadcrumbs.tsx
var MuiBreadcrumbs = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        fontSize: "16px",
        marginBottom: "16px",
        "& a": {
          textDecoration: "none"
        },
        "& a:hover": {
          textDecoration: "underline"
        },
        "& li:last-child a": {
          color: theme.palette.text.primary
        },
        "& li:not(:last-child) a": {
          color: theme.palette.text.secondary
        }
      };
    }
  }
};

// src/theme/sections/components/MuiCssBaseline.tsx
var MuiCssBaseline = {
  styleOverrides: {
    html: `
        @font-face {
          font-family: 'Averta';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: url('/fonts/averta-regular.otf') format('opentype');
        }
        @font-face {
          font-family: 'Averta Light';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: url('/fonts/averta-light.otf') format('opentype');
        }
        @font-face {
          font-family: 'Averta Semibold';
          font-style: normal;
          font-display: swap;
          font-weight: 600;
          src: url('/fonts/averta-semibold.otf') format('opentype');
        }
        @font-face {
          font-family: 'Averta Bold';
          font-style: normal;
          font-display: swap;
          font-weight: 700;
          src: url('/fonts/averta-bold.otf') format('opentype');
        }
      `,
    body: {
      scrollbarColor: `colors.grey[400] ${colors.whites[100]}`,
      "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
        backgroundColor: colors.whites[100]
      },
      "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
        borderRadius: 8,
        backgroundColor: colors.grey[400],
        minHeight: 24,
        border: `3px solid ${colors.whites[100]}`
      },
      "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
        backgroundColor: colors.grey[600]
      },
      "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
        backgroundColor: colors.grey[600]
      },
      "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
        backgroundColor: colors.grey[600]
      },
      "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
        backgroundColor: colors.whites[100]
      }
    }
  }
};

// src/theme/sections/components/MuiDataGrid.tsx
var MuiDataGrid = {
  defaultProps: {
    density: "compact"
  },
  styleOverrides: {
    root: ({ theme }) => {
      return {
        "& .MuiDataGrid-cell--editable:hover": {
          cursor: "pointer",
          ".MuiDataGrid-cellContent": {
            backgroundColor: theme.palette.background.default,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "4px",
            cursor: "text",
            padding: "4px 0",
            width: "100%"
          }
        },
        "& .MuiDataGrid-cell--editable.MuiDataGrid-cell--textRight:hover": {
          textAlign: "right"
        }
      };
    }
  }
};

// src/theme/sections/components/MuiInputBase.tsx
var MuiInputBase = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      const borderColor = ownerState.color === "primary" || ownerState.color === "secondary" ? getColorPercentage(colors.black[600], 23) : ownerState.color;
      const borderHoverColor = ownerState.color === "primary" || ownerState.color === "secondary" ? getColorPercentage(colors.black[600], 40) : ownerState.color;
      const borderHoverErrorColor = theme.palette.error.main;
      return {
        "&.MuiInputBase-root": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor,
            borderRadius: `4px`
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: ownerState.error ? borderHoverErrorColor : borderHoverColor
          }
        },
        "&.MuiInputBase-root.Mui-focused": {
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: ownerState.error ? borderHoverErrorColor : theme.palette.primary.main
          }
        },
        "&.Mui-disabled": {
          "&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            backgroundColor: theme.palette.grey[50],
            border: `1px dashed ${getColorPercentage(colors.black[600], 23)}`
          },
          svg: {
            zIndex: 9999
          }
        }
      };
    }
  }
};

// src/theme/sections/components/MuiFormLabel.tsx
var MuiFormLabel = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
      lineHeight: "24px"
    })
  }
};

// src/theme/sections/components/MuiButton.tsx
var MuiButton = {
  defaultProps: {
    disableElevation: true
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      const { size } = ownerState;
      let borderRadius = theme.shape.borderRadius;
      if (size === "small") {
        borderRadius = 6;
      }
      return __spreadProps(__spreadValues(__spreadValues(__spreadValues({
        borderRadius
      }, ownerState.variant === "outlined" && {
        border: `1px solid ${getColorPercentage(colors.black[600], 15)}`
      }), ownerState.size === "medium" && {
        lineHeight: "24px",
        padding: "8px 16px",
        "& .MuiButton-startIcon": {
          marginRight: "4px"
        }
      }), ownerState.size === "small" && {
        fontSize: "14px",
        lineHeight: "20px",
        padding: "6px 12px",
        "& .MuiButton-startIcon": {
          marginRight: "3px"
        }
      }), {
        textTransform: "none",
        fontSize: "16px",
        fontWeight: 600
      });
    }
  }
};

// src/theme/sections/components/MuiButtonGroup.tsx
var MuiButtonGroup = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      return __spreadValues(__spreadValues({}, ownerState.variant === "outlined" && {
        "& button": {
          color: colors.black[600]
        }
      }), ownerState.variant === "text" && {
        "& button": {
          color: colors.black[600]
        }
      });
    }
  }
};

// src/theme/sections/components/MuiCheckbox.tsx
var MuiCheckbox = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      return __spreadValues(__spreadValues(__spreadValues({}, ownerState.color === "secondary" && {
        "& .MuiSvgIcon-root": {
          color: theme.palette.secondary.contrastText
        }
      }), ownerState.size === "medium" && {
        "& .MuiSvgIcon-root": {
          fontSize: "24px"
        }
      }), ownerState.size === "small" && {
        "& .MuiSvgIcon-root": {
          fontSize: "15px"
        }
      });
    }
  }
};

// src/theme/sections/components/MuiChip.tsx
var MuiChip = {
  styleOverrides: {
    root: ({ ownerState }) => {
      return __spreadValues({}, ownerState.variant === "outlined" && {
        borderColor: ownerState.color === "error" ? colors.red[700] : colors.grey[400]
      });
    }
  }
};

// src/theme/sections/components/MuiRadio.tsx
var MuiRadio = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      return __spreadValues({}, ownerState.color === "secondary" && {
        "& .MuiSvgIcon-root": {
          color: theme.palette.secondary.contrastText
        }
      });
    }
  }
};

// src/theme/sections/components/MuiTooltip.tsx
var MuiTooltip = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      borderRadius: "4px",
      boxShadow: theme.shadows[4],
      fontSize: "14px",
      lineHeight: "16px",
      letterSpacing: "0",
      maxWidth: "240px"
    })
  }
};

// src/theme/sections/components/MuiSelect.tsx
var MuiSelect = {
  styleOverrides: __spreadValues({
    // seems like you need at least one object or else its complains so just adding this here for that
    select: {}
  }, {
    root: ({ theme }) => ({
      "&.Mui-disabled": {
        "&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
          backgroundColor: theme.palette.grey[50],
          border: `1px dashed ${getColorPercentage(colors.black[600], 23)}`
        }
      }
    })
  })
};

// src/theme/sections/components/MuiFormHelperText.tsx
var MuiFormHelperText = {
  styleOverrides: {
    root: {
      letterSpacing: "0.4px",
      lineHeight: "166%",
      marginLeft: 0
    }
  }
};

// src/theme/sections/components/MuiTabs.tsx
var MuiTabs = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        "& .MuiButtonBase-root": {
          borderBottom: "2px solid transparent",
          fontWeight: 700,
          textTransform: "none",
          fontSize: "14px",
          padding: 0,
          minWidth: 0,
          marginRight: "24px"
        },
        "& .MuiButtonBase-root:hover": {
          borderBottom: `2px solid ${theme.palette.text.secondary}`,
          color: theme.palette.text.secondary,
          fontWeight: 700,
          fontSize: "14px",
          padding: 0,
          minWidth: 0,
          marginRight: "24px"
        }
      };
    }
  }
};

// src/theme/sections/components/MuiList.tsx
var MuiList = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        "& .MuiMenuItem-root:hover": {
          backgroundColor: getColorPercentage(colors.black[700], 4)
        },
        "& .MuiMenuItem-root.Mui-selected": {
          backgroundColor: theme.palette.primary.selected
        },
        "& .MuiIcon-root": {
          color: theme.palette.action.active
        }
      };
    }
  }
};

// src/theme/sections/components/MuiIcon.tsx
var MuiIcon = {
  defaultProps: {
    baseClassName: "material-symbols-rounded",
    fontSize: "small"
  },
  styleOverrides: {
    root: ({ ownerState }) => {
      return __spreadValues(__spreadValues(__spreadValues(__spreadValues({
        color: ownerState.color || getColorPercentage(colors.black[700], 87)
      }, ownerState.fontSize === "xSmall" && {
        fontSize: "16px"
      }), ownerState.fontSize === "small" && {
        fontSize: "20px"
      }), ownerState.fontSize === "medium" && {
        fontSize: "24px"
      }), ownerState.fontSize === "large" && {
        fontSize: "35px"
      });
    }
  }
};

// src/theme/sections/components/MuiBadge.tsx
var MuiBadge = {
  styleOverrides: {
    badge: ({ ownerState }) => {
      const { badgeContent } = ownerState;
      return {
        border: `2px solid ${colors.whites[50]}`,
        fontSize: "12px",
        fontWeight: 600,
        letterSpacing: "0.14px",
        lineHeight: "20px",
        padding: "0 5px",
        borderRadius: "50%",
        height: badgeContent ? "unset" : "14px",
        minWidth: badgeContent ? "24px" : "14px"
      };
    }
  }
};

// src/theme/sections/components/MuiInputLabel.tsx
var MuiInputLabel = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        color: theme.palette.text.secondary
      };
    }
  }
};

// src/theme/sections/components/MuiRating.tsx
import { Icon } from "@mui/material";
import React2 from "react";
var MuiRating = {
  defaultProps: {
    className: "material-symbols-rounded",
    emptyIcon: /* @__PURE__ */ React2.createElement(
      Icon,
      {
        fontSize: "inherit",
        sx: {
          color: colors.grey[300]
        }
      },
      "star"
    )
  },
  styleOverrides: {
    iconFilled: ({ ownerState }) => ({
      color: ownerState.color ? ownerState.color : colors.yellow[700]
    }),
    root: ({ ownerState }) => ({
      "& .MuiRating-decimal:not(:first-of-type)": {
        marginLeft: "-2px"
      },
      "& label:not(:first-of-type)": {
        marginLeft: ownerState.precision === 1 ? "-2px" : "0"
      }
    })
  },
  variants: [
    {
      props: {
        color: ""
      },
      style: {}
    }
  ]
};

// src/theme/sections/components/MuiSnackbar.tsx
import React3 from "react";
var MuiSnackbar = {
  defaultProps: {
    action: /* @__PURE__ */ React3.createElement(React3.Fragment, null)
  },
  styleOverrides: {
    root: () => {
      return {
        "& .MuiAlert-root": {
          borderRadius: "16px"
        }
      };
    }
  }
};

// src/theme/MindbodyBase.tsx
var boxShadowColor = getColorPercentage(colors.black[600], 20);
var MindbodyBaseTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    }
  },
  components: {
    MuiCssBaseline,
    MuiAlert,
    MuiAlertTitle,
    MuiAvatar,
    MuiBadge,
    MuiBreadcrumbs,
    MuiButton,
    MuiButtonGroup,
    MuiCheckbox,
    MuiChip,
    MuiDataGrid,
    MuiFormLabel,
    MuiFormHelperText,
    MuiIcon,
    MuiInputBase,
    MuiInputLabel,
    MuiList,
    MuiRadio,
    MuiRating,
    MuiSelect,
    MuiSnackbar,
    MuiTabs,
    MuiTooltip
  },
  palette: paletteBusiness,
  shape: {
    borderRadius: 16
  },
  shadows: [
    `none`,
    `0 1px 3px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 1px 16px ${boxShadowColor}`,
    `0 1px 24px ${boxShadowColor}`,
    // UX does not use these shadows and since we need to define them, setting to none
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`,
    `0 4px 12px ${boxShadowColor}`
  ],
  spacing: [4, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96],
  typography: {
    fontFamily: ["Averta", "Helvetica Neue", "Arial", "sans-serif"].join(","),
    fontSize: 16,
    h1: {
      fontSize: "48px",
      fontWeight: 700,
      lineHeight: "116%",
      letterSpacing: "-1.5px"
    },
    h2: {
      fontSize: "40px",
      fontWeight: 600,
      lineHeight: "120%",
      letterSpacing: "-0.5px"
    },
    h3: {
      fontSize: "34px",
      fontWeight: 600,
      lineHeight: "117%",
      letterSpacing: "-0.5px"
    },
    h4: {
      fontSize: "28px",
      fontWeight: 600,
      lineHeight: "116%",
      letterSpacing: "-0.5px"
    },
    h5: {
      fontSize: "23px",
      fontWeight: 600,
      lineHeight: "140%",
      letterSpacing: "0"
    },
    h6: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "134%",
      letterSpacing: "0"
    },
    subtitle1: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "150%",
      letterSpacing: "0"
    },
    subtitle2: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "115%",
      letterSpacing: "0"
    },
    body1: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "150%",
      letterSpacing: "0"
    },
    body2: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "115%",
      letterSpacing: "0"
    },
    caption: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "137%",
      letterSpacing: "0.15px"
    },
    overline: {
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "136%",
      letterSpacing: "1px",
      textTransform: "uppercase"
    }
  }
});
var MindbodyBase = MindbodyBaseTheme;

// src/theme/MindbodyRebrand.tsx
import { createTheme as createTheme2 } from "@mui/material/styles";

// src/theme/sections/components/rebrandOverrides/MuiButton.tsx
var MuiButton2 = {
  defaultProps: {
    disableElevation: true
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      return __spreadValues(__spreadValues(__spreadValues(__spreadValues({
        textTransform: "none",
        fontSize: "16px",
        fontWeight: 600
      }, ownerState.color === "success" && {
        backgroundColor: theme.palette.success.main,
        "&:hover": {
          backgroundColor: theme.palette.success.dark
        }
      }), ownerState.variant === "outlined" && {
        border: `1px solid ${getColorPercentage(colors.black[600], 15)}`,
        "&:hover": {
          border: `1px solid ${getColorPercentage(colors.black[600], 15)}`
        }
      }), ownerState.size === "medium" && {
        lineHeight: "24px",
        padding: "8px 16px",
        "& .MuiButton-startIcon": {
          marginRight: "4px"
        }
      }), ownerState.size === "small" && {
        borderRadius: 6,
        fontSize: "14px",
        lineHeight: "20px",
        padding: "6px 12px",
        "& .MuiButton-startIcon": {
          marginRight: "3px"
        }
      });
    }
  }
};

// src/theme/sections/components/rebrandOverrides/MuiInputBase.tsx
var MuiInputBase2 = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      const borderColor = ownerState.color === "primary" || ownerState.color === "secondary" ? getColorPercentage(colors.black[600], 23) : ownerState.color;
      return {
        borderColor,
        "&.MuiInputBase-root": {
          borderRadius: `4px`
        }
      };
    }
  }
};

// src/theme/sections/components/rebrandOverrides/MuiPickersDay.tsx
var MuiPickersDay = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        "&.Mui-selected": {
          backgroundColor: `${theme.palette.secondary.main} !important`
        }
      };
    }
  }
};

// src/theme/sections/components/rebrandOverrides/MuiAlert.tsx
import React4 from "react";
var MuiAlert2 = {
  defaultProps: {
    action: /* @__PURE__ */ React4.createElement(React4.Fragment, null)
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      let borderColor = theme.palette.primary.main;
      let background = theme.palette.background.default;
      let textColor = theme.palette.text.primary;
      switch (ownerState == null ? void 0 : ownerState.severity) {
        case "error":
          borderColor = theme.palette.error.main;
          background = theme.palette.error.light;
          textColor = theme.palette.error.dark;
          break;
        case "info":
          borderColor = theme.palette.info.main;
          background = theme.palette.info.light;
          textColor = theme.palette.info.dark;
          break;
        case "success":
          borderColor = theme.palette.success.main;
          background = theme.palette.success.light;
          textColor = theme.palette.success.dark;
          break;
        case "warning":
          borderColor = theme.palette.warning.main;
          background = theme.palette.warning.light;
          textColor = theme.palette.warning.dark;
          break;
        default:
          borderColor = theme.palette.primary.main;
          background = theme.palette.background.default;
          textColor = theme.palette.text.primary;
      }
      return {
        background,
        border: `1px solid ${borderColor}`,
        borderRadius: "4px",
        color: textColor,
        "& .MuiAlert-message": {
          padding: "10px 0"
        }
      };
    }
  }
};

// src/theme/sections/components/rebrandOverrides/MuiSnackbar.tsx
import React5 from "react";
var MuiSnackbar2 = {
  defaultProps: {
    action: /* @__PURE__ */ React5.createElement(React5.Fragment, null)
  },
  styleOverrides: {
    root: () => {
      return {
        "& .MuiAlert-root": {
          borderRadius: "16px"
        }
      };
    }
  }
};

// src/theme/sections/components/rebrandOverrides/MuiFilledInput.tsx
var MuiFilledInput = {
  defaultProps: {
    disableUnderline: true
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      return {
        "&.MuiFilledInput-root": {
          outline: `1px solid ${colors.black[400]}`,
          backgroundColor: "transparent",
          "&:hover": {
            outlineColor: colors.black[600]
          },
          "&.Mui-focused": {
            outline: `2px solid ${theme.palette.primary.main}`
          },
          "&.Mui-error": {
            outlineColor: theme.palette.error.main
          },
          "&.Mui-disabled": {
            outlineColor: colors.black[100],
            backgroundColor: colors.black[100],
            color: colors.black[500],
            "&:hover": {
              outlineColor: colors.black[100]
            }
          }
        }
      };
    },
    input: ({ theme, ownerState }) => {
      return {
        "&.MuiFilledInput-input": {
          "&:focus": {
            background: "transparent"
          },
          "&.Mui-disabled": {
            color: colors.black[500],
            textFillColor: colors.black[500]
          }
        }
      };
    }
  }
};

// src/theme/sections/components/rebrandOverrides/MuiFormControl.tsx
var MuiFormControl = {
  defaultProps: {
    variant: "filled"
  }
};

// src/theme/sections/components/rebrandOverrides/MuiInputLabel.tsx
var MuiInputLabel2 = {
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      return {
        "&.Mui-disabled": {
          color: colors.black[500]
        }
      };
    }
  }
};

// src/theme/sections/components/rebrandOverrides/MuiTextField.tsx
var MuiTextField = {
  defaultProps: {
    variant: "filled"
  }
};

// src/theme/MindbodyRebrand.tsx
var MindbodyRebrandTheme = createTheme2(__spreadProps(__spreadValues({}, MindbodyBase), {
  components: __spreadProps(__spreadValues({}, MindbodyBase.components), {
    MuiButton: MuiButton2,
    MuiInputBase: MuiInputBase2,
    MuiFilledInput,
    MuiPickersDay,
    MuiAlert: MuiAlert2,
    MuiSnackbar: MuiSnackbar2,
    MuiFormControl,
    MuiInputLabel: MuiInputLabel2,
    MuiTextField
  }),
  shape: {
    borderRadius: 8
  },
  typography: {
    fontFamily: ["DM Sans", "Averta", "Helvetica Neue", "Arial", "sans-serif"].join(","),
    fontSize: 16,
    h1: {
      fontSize: "52px",
      fontWeight: 700,
      lineHeight: "100%",
      letterSpacing: "-1.5px"
    },
    h2: {
      fontSize: "36px",
      fontWeight: 600,
      lineHeight: "125%",
      letterSpacing: "-0.5px"
    },
    h3: {
      fontSize: "36px",
      fontWeight: 600,
      lineHeight: "125%",
      letterSpacing: "-0.5px"
    },
    h4: {
      fontSize: "28px",
      fontWeight: 600,
      lineHeight: "140%",
      letterSpacing: "-0.5px"
    },
    h5: {
      fontSize: "20px",
      fontWeight: 600,
      lineHeight: "140%",
      letterSpacing: "0"
    },
    h6: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "140%",
      letterSpacing: "0"
    },
    subtitle1: {
      fontSize: "16px",
      fontWeight: 700,
      lineHeight: "140%",
      letterSpacing: "0"
    },
    subtitle2: {
      fontSize: "14px",
      fontWeight: 700,
      lineHeight: "140%",
      letterSpacing: "0"
    },
    body1: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "140%",
      letterSpacing: "0"
    },
    body2: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "140%",
      letterSpacing: "0"
    },
    caption: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "140%",
      letterSpacing: "0.15px"
    },
    overline: {
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "140%",
      letterSpacing: "1px",
      textTransform: "uppercase"
    }
  },
  palette: paletteRebrand
}));
var MindbodyRebrand = MindbodyRebrandTheme;

// src/theme/MindbodyBusiness.tsx
import { createTheme as createTheme3 } from "@mui/material/styles";

// src/theme/sections/components/businessOverrides/MuiButton.tsx
var MuiButton3 = {
  defaultProps: {
    disableElevation: true
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      return __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, ownerState.variant === "outlined" && __spreadValues({
        border: `1px solid ${ownerState.color === "primary" || ownerState.color === "secondary" ? getColorPercentage(colors.black[600], 15) : ownerState.color}`
      }, ownerState.color === "secondary" && {
        color: theme.palette.secondary.contrastText
      })), ownerState.size === "medium" && {
        lineHeight: "24px",
        padding: "8px 16px",
        "& .MuiButton-startIcon": {
          marginRight: "4px"
        }
      }), ownerState.size === "small" && {
        borderRadius: 6,
        fontSize: "14px",
        lineHeight: "20px",
        padding: "6px 12px",
        "& .MuiButton-startIcon": {
          marginRight: "3px"
        }
      }), {
        textTransform: "none",
        fontSize: "16px",
        fontWeight: 600
      });
    }
  }
};

// src/theme/MindbodyBusiness.tsx
var MindbodyBusinessTheme = createTheme3(__spreadProps(__spreadValues({}, MindbodyBase), {
  components: __spreadProps(__spreadValues({}, MindbodyBase.components), {
    MuiButton: MuiButton3
  }),
  shape: {
    borderRadius: 8
  },
  palette: paletteBusiness
}));
var MindbodyBusiness = MindbodyBusinessTheme;

// src/theme/MindbodyConsumer.tsx
import { createTheme as createTheme4 } from "@mui/material/styles";

// src/theme/sections/components/consumerOverrides/MuiInputBase.tsx
var MuiInputBase3 = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      const borderColor = ownerState.color === "primary" || ownerState.color === "secondary" ? getColorPercentage(colors.black[600], 23) : ownerState.color;
      return {
        borderColor,
        "&.MuiInputBase-root": {
          borderRadius: `4px`
        }
      };
    }
  }
};

// src/theme/MindbodyConsumer.tsx
var MindbodyConsumerTheme = createTheme4(__spreadProps(__spreadValues({}, MindbodyBase), {
  palette: paletteConsumer,
  components: __spreadProps(__spreadValues({}, MindbodyBase.components), {
    MuiInputBase: MuiInputBase3
  })
}));
var MindbodyConsumer = MindbodyConsumerTheme;

// src/theme/theme.tsx
var ThemeVariant = /* @__PURE__ */ ((ThemeVariant2) => {
  ThemeVariant2["Consumer"] = "Consumer";
  ThemeVariant2["MindbodyRebrand"] = "MindbodyRebrand";
  ThemeVariant2["Business"] = "Business";
  return ThemeVariant2;
})(ThemeVariant || {});
export {
  MindbodyBase,
  MindbodyBusiness,
  MindbodyConsumer,
  MindbodyRebrand,
  ThemeVariant,
  colors
};
